import { CognitoAuth, StorageHelper } from 'amazon-cognito-auth-js';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import UserInfoStore from './user-info-store';

const APP_DOMAIN = process.env.VUE_APP_COGNITO_APP_DOMAIN;
const CLIENT_ID = process.env.VUE_APP_COGNITO_CLIENT_ID;
const USERPOOL_ID = process.env.VUE_APP_COGNITO_USERPOOL_ID;

const authData = {
  ClientId: CLIENT_ID,
  AppWebDomain: APP_DOMAIN,
  TokenScopesArray: ['openid', 'email', 'profile'],
  RedirectUriSignIn: `${window.location.origin}/callback`,
  RedirectUriSignOut: `${window.location.origin}/logout`,
  UserPoolId: USERPOOL_ID
};

const auth = new CognitoAuth(authData);
auth.userhandler = {
  onSuccess(result) {
    console.log('On Success result', result);
    UserInfoStore.setLoggedIn(true);
    window.location.href = '/';
  },
  onFailure(err) {
    console.log('Error with auth: ', err);
    UserInfoStore.setLoggedOut();
    window.location.href = '/error';
  }
};

function getUserInfo() {
  const { jwtToken } = auth.getSignInUserSession().getAccessToken();
  const USERINFO_URL = `https://${auth.getAppWebDomain()}/oauth2/userInfo`;
  const requestData = {
    headers: {
      Authorization: `Bearer ${jwtToken}`
    }
  };

  const jwtProperties = jwtDecode(jwtToken);
  console.log('jwt props: ', jwtProperties);

  const lowerCaseGroups = [];

  if (jwtProperties && jwtProperties['cognito:groups']) {
    jwtProperties['cognito:groups'].forEach(item => {
      lowerCaseGroups.push(item.toLowerCase());
    });
  }

  return axios.get(USERINFO_URL, requestData).then(response => {
    const cognitoProperties = {
      groups: lowerCaseGroups,
      userInfo: response.data
    };

    return cognitoProperties;
  });
}

function getUserInfoStorageKey() {
  const keyPrefix = `CognitoIdentityServiceProvider.${auth.getClientId()}`;
  const tokenUserName = auth.signInUserSession.getAccessToken().getUsername();
  const userInfoKey = `${keyPrefix}.${tokenUserName}.userInfo`;
  return userInfoKey;
}

const storageHelper = new StorageHelper();
const storage = storageHelper.getStorage();

export default {
  auth,
  login() {
    auth.getSession();
  },
  logout() {
    if (auth.isUserSignedIn()) {
      const userInfoKey = this.getUserInfoStorageKey();
      auth.signOut();

      storage.removeItem(userInfoKey);
    }
  },
  getUserInfoStorageKey,
  getUserInfo
};
